export function isEmail(str?: string) {
	return !!str?.includes('@');
}
